import React from 'react';
import { Link } from 'react-router-dom';
import { FiFileText, FiCreditCard, FiFile, FiClock } from 'react-icons/fi';
import { useAuthStore } from '../context/store';
import { getBrand } from '../utils/brand';

const cards = [
  { to: '/booking-confirmation', icon: '🏕️', title: 'Booking Confirmation', desc: 'Create new booking & generate confirmation text', color: 'from-primary-700 to-primary-900', iconBg: 'bg-primary-50' },
  { to: '/payment-received', icon: '💳', title: 'Payment Received Mail', desc: 'Generate email text & PDF receipt after payment', color: 'from-primary-600 to-primary-800', iconBg: 'bg-primary-50' },
  { to: '/pdf-content', icon: '📄', title: 'PDF Content', desc: 'View, regenerate & manage PDF receipts', color: 'from-primary-500 to-primary-700', iconBg: 'bg-primary-50' },
  { to: '/payment-reminder', icon: '⏰', title: 'Payment Reminder', desc: 'Generate payment reminder messages', color: 'from-yellow-400 to-yellow-500', iconBg: 'bg-yellow-50' },
  { to: '/confirmed-bookings', icon: '✅', title: 'Confirmed Bookings', desc: 'View confirmed bookings & add comments', color: 'from-green-500 to-green-700', iconBg: 'bg-green-50' },
];

export default function Dashboard() {
  const { user } = useAuthStore();
  const brand = getBrand(user?.brand);
  return (
    <div>
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900">Welcome to {brand.name} {brand.icon}</h1>
        <p className="text-gray-500 mt-1">Select an action to get started</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {cards.map(card => (
          <Link key={card.to} to={card.to}
            className="group block bg-white rounded-xl shadow-sm border border-gray-100 hover:shadow-lg hover:border-primary-200 transition-all duration-200 overflow-hidden">
            <div className={`h-2 bg-gradient-to-r ${card.color}`}></div>
            <div className="p-6 flex items-start space-x-4">
              <div className={`text-4xl ${card.iconBg} p-3 rounded-lg group-hover:scale-110 transition-transform`}>
                {card.icon}
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-900 group-hover:text-primary-700 transition">
                  {card.title}
                </h3>
                <p className="text-sm text-gray-500 mt-1">{card.desc}</p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
